export enum actionTypes {
    UPDATE_FORMS_DATA = 'UPDATE_FORMS_DATA'
}
